export default "__VITE_ASSET__DGj6RquJ__"